import { Button, createStyles, Link, makeStyles, Theme, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { default as React, useEffect, useState } from "react";
import translate from "../../../i18n/translate";
import { ILearnerSessions } from "../../../interfaces";
import "./MyScheduleSummaryBlock.scss";
import { useSelector, useDispatch } from "react-redux";
import { onboardingVideoUrls } from "../../../globalConstants";
import allActions from "../../../redux/actions";
import { useLocation } from "react-router-dom";
import ModalPopup from "../../shared/ModalPopup/ModalPopup";
import VideoPlayer from "../../shared/VideoPlayer/VideoPlayer";
import ReschedulePopup from "./ReschedulePopup";
import CancelPopup from "./CancelPopup";

let rescheduleWindow: any;

const LatestUpcomingBlock = (props: any) => {
  const [calPopup, setCalPopup] = useState(false);
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  const location: any = useLocation();  
  const [upcomingsession, setSessionId] = useState(0);
  const [openPopup, setPopupState] = useState(false);
  const [openCancel, setCancelPopUp] = useState(false);
  const [openVideo, setOpenVideo] = useState<boolean>(false);
  const [cancelProps, setCancelProps] = useState({} as ILearnerSessions);

  const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      border: '1px solid',
      padding: theme.spacing(1),
      backgroundColor: theme.palette.background.paper,
    },
  }),
);
const classes = useStyles();
  const openRescheduleWindow = (sessionId: number) => {
    let w = 630;
    let h = 440; // default sizes
    if (window.screen) {
      w = window.screen.availWidth - 10;
      h = window.screen.availHeight - 70;
    }
    rescheduleWindow = window.open(
      `${process.env.REACT_APP_TMS_URL}` + "/v2/sessions/" + sessionId + "/reschedule",
      "Reschedule Session",
      "height=" +
      h +
      ",width=" +
      w +
      ",dependent=yes,location=no,menubar=no," +
      "resizable=yes,scrollbars=yes,status=no,toolbar=no"
    );
    rescheduleWindow.focus();
    checkWindowCloseTimer(rescheduleWindow);
  };
  const checkWindowCloseTimer = (learnerWindow: any) => {

    const checkTimer: any = setInterval(() => {
      if (learnerWindow.closed) {
        clearInterval(checkTimer);
        const courseId: number = Number(sessionStorage.getItem("courseId")) || 0;
        if (!allInfo.createSessionService.isLoading) {
          dispatch(allActions.createSessionServiceAction.createSessionService(courseId));
        }
        if (!allInfo.tmsLearnerSessions.isLoading) {
          dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
        }
      }
    }, 1000);
  };
  const handleClick = (sessionId: number) => {
    if (sessionStorage.getItem("RescheduleChkBox") === "False") {
      setPopupState(true);
      setSessionId(sessionId);
    } else {
      setPopupState(false);
      openRescheduleWindow(sessionId);
    }
  };
  const openJoinNowSession = (classRoomLink: any) => {
    let playVideo = false;
    let w = 7680;
    let h = 4320; // default sizes
    if (window.screen) {
      w = window.screen.availWidth - 10;
      h = window.screen.availHeight - 70;
    }
    const roomWindow = window.open(
      classRoomLink,
      "Classroom Window",
      "height=" +
      h +
      ",width=" +
      w +
      ",dependent=yes,location=no,menubar=no," +
      "resizable=yes,scrollbars=yes,status=no,toolbar=no"
    );
    if (roomWindow != null) {
      roomWindow.focus();
    }
  };
  const handleCancel = (cancelData: ILearnerSessions) => {
    setCancelPopUp(true);
    setCancelProps(cancelData);
  };
  const handleJoinNow = () => {
    if (sessionStorage.getItem("isDemoUser")) {
      setOpenVideo(true);   
    } else {
      if (props.isJoinNowEnabled) {
        openJoinNowSession(props.classRoomLink);
      }
    }
  };
  const handleClose = () => {
    setCalPopup(false);
  };

  const getDemoLicenseSource = () => {
    let isOnboardingVideoAvailable = onboardingVideoUrls.find((obj: any) => obj.productId === location?.state?.productId);
    return isOnboardingVideoAvailable?.url ? isOnboardingVideoAvailable?.url : "";
  }

  const isButtonActive = () => {
    let isOnboardingVideoAvailable = onboardingVideoUrls.find((obj: any) => obj.productId === location?.state?.productId);
    return (!props.isJoinNowEnabled || (sessionStorage.getItem("isDemoUser") && (!isOnboardingVideoAvailable?.url))) ? true : false;
  }

  const [isSkillGroupNext, setIsSkillGroupNext] = useState(false);  
  useEffect(() => {
  if(allInfo.peopleInformation.data){
    const licenseList = allInfo.peopleInformation.data.getpeopleInformation.license;
    if(licenseList){
      let sprintGroupsCheck: any = licenseList.filter((prod: any) => {
        return prod.productId === "29";
      });      
      if(sprintGroupsCheck.length > 0){
        setIsSkillGroupNext(true);
      }      
    }    
  }
  }, [allInfo.peopleInformation.data])

  return (
    <React.Fragment>
      {Object.keys(props.RecentData).length > 0 && (
        <React.Fragment>
          <div className="sub-header">
          <span className="recent-session-font">{translate("myschedule_next_session")}</span>
          <div>
            {/* HIDING ADD TO CALENDAR BUTTON, WILL UNCOMMENT LATER */}
              {/* <Button
                  className={
                    (!props.calendarEvents.length && "button primary joinnow-button-inactive") || "button primary large"}
                  type="button" variant="contained" color="primary"  aria-describedby="button-export-events" onClick={() => setCalPopup(true)}>
                 <img className="add-to-calendar-image" src={"../../../images/schedule-calendar/event-calendar.svg"}></img> <Typography className="add-to-calendar-button">{translate("twt_add_to_calendar")}</Typography>
                </Button> */}
                </div>
              </div>
          <div className="schedule-container">
            <div className="next-schedule-details">
              <div>
                <span>{translate("myschedule_sessionDetails_teacher_name")}</span>
                <span>{props.RecentData.CoachName}</span>
              </div>
              <div>
                <span>{translate("myschedule_sessionDetails_date")} / {translate("myschedule_sessionDetails_time")}</span>
                <span>
                  {props.RecentData.Session_GetstartDate} / {props.RecentData.StartTime}
                </span>
              </div>
              <div>
                <Button id="joinNowEnableDisable"
                  className={isButtonActive() ? "button primary joinnow-button-inactive" : "button primary large"}
                  disabled = {isButtonActive()}
                  type="button" 
                  variant="contained" 
                  color="primary" 
                  onClick={() => handleJoinNow()}>
                  <span className="submit-text">{translate("myschedule_upcoming_joinNow")}</span>
                </Button>
                {openVideo && (
                  <ModalPopup
                    toggleOpen={openVideo}
                    setOpen={setOpenVideo}
                    classNameProps="video-card"
                    body={
                      <React.Fragment>
                        <VideoPlayer 
                          source={getDemoLicenseSource()} 
                          isplaying ={true} 
                          width={'93vw'} 
                          height={'95vh'} 
                          controls={true} 
                          fullscreen={true}>                          
                        </VideoPlayer>
                        <div className="closeVideo" onClick={() => setOpenVideo(false)} onKeyDown={() => {}}>x</div>
                      </React.Fragment>
                    }
                  />
                )}
              </div>
              <div>
                {props.RecentData.IconType === "Cancel" && props.isCancelVisible && (
                  <span className="Reschedule_text_button" onClick={() => handleCancel(props.RecentData)} onKeyDown={() => {}}>
                    {translate("profile_cancelLabel")}
                  </span>
                )}
                {props.RecentData.IconType === "Reschedule" && (
                  !isSkillGroupNext ? 
                  <span className="Reschedule_text_button" onClick={() => handleClick(props.RecentData.SessionId)} onKeyDown={() => {}}>
                    {translate("myschedule_reschedule_button")}
                  </span>: <></>                
                )}
                {props.RecentData.IconType === "N/A" && "N/A"}
              </div>
            </div>
          </div>
          <div>
      <Dialog
        open={calPopup}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className ="scheduler-popup"
       
      >
      <DialogTitle className="calendar-title">{translate("myschedule_addToCalendar_instr1")}</DialogTitle>
      <DialogContent>
      <DialogContentText className="calendar-dialog-text">
        <ul>
          <li>{translate("myschedule_addToCalendar_instr1")} <img src={"../../../images/schedule-calendar/download-icon.svg"} className="calendar-download-icon" alt="calendar-icon"></img>{translate("myschedule_addToCalendar_instr2")}</li>
          <br></br>
          <li>{translate("myschedule_addToCalendar_instr3")}</li>
          <br></br>
          <li>{translate("myschedule_addToCalendar_instr4")} <Link href="#">{translate("myschedule_addToCalendar_instr5")}</Link></li>
        </ul>
        </DialogContentText>
      <div className="calendar-download-button"> 
        <span className="calendar-button-align">
          <Button className={
            (!props.calendarEvents.length && "button primary joinnow-button-inactive calendar-button-align") || "button primary large calendar-button-align"} type="button" variant="contained" color="primary"  aria-describedby="button-export-events" onClick={() => props.handleCalendarClick()}>
              <Typography className="calendar-dialog-text"> 
                <img src={"../../../images/schedule-calendar/download-icon.svg"} className="calendar-download-icon" alt="calendar-icon"></img> {"   Download"}
              </Typography>
          </Button> 
        </span>
      </div>
      </DialogContent>
  
      </Dialog>
      </div>
        </React.Fragment>
      )}
      {openPopup && (
        <ReschedulePopup
          prodName={props.prodName}
          currentSessionId={upcomingsession}
          openPopup={openPopup}
          setPopupState={setPopupState}
          handleDispatch={props.handleDispatch}
        />
      )}
      {openCancel && (
        <CancelPopup cancelProps={cancelProps} setCancelPopUp={setCancelPopUp} openCancel={openCancel} setJoinNow={props.setJoinNow} isLatestCancel={true}></CancelPopup>
      )}
    </React.Fragment>
  );
};

export default LatestUpcomingBlock;